import axios from "axios";
import jwt from "jsonwebtoken";

const API_URL = process.env.REACT_APP_API_BASE_URL;

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "/jwt-auth/v1/token", {
        username,
        password
      })
      .then(response => {
        if (response.data.token) {
          localStorage.setItem("wp-user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("wp-user");
  }

  /* register(username, password) {
    return axios.post(API_URL + "/user/register/", {
      username,
      password
    });
  } */

  getCurrentUser() {
    const current = JSON.parse(localStorage.getItem('wp-user'));
    if (!current) {
      return false;
    }
    const token = current.token;
    let decodedToken = jwt.decode(token, {complete: true});
    let dateNow = new Date();
    let dateNowSeconds = dateNow.getTime() / 1000;
    console.log("token exp: " + decodedToken.payload.exp + " / now: " + dateNowSeconds);
    if(decodedToken.payload.exp < dateNowSeconds) {
      return false;
    } else {
      console.log("current user is valid");
      return JSON.parse(localStorage.getItem('wp-user'));
    } 
  }
}

export default new AuthService();